// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"DropdownMenu_innerContainer__2WMqK","iconWrapper":"DropdownMenu_iconWrapper__3pMEL"};